module.exports = __webpack_public_path__ + "static/media/DSC_0151-2.510876cc.jpg";